import { apiClient } from "@/lib/apiClient";
import { type UserRole } from "@repo/schemas/permissionSchema";

export interface LocalUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: {
    id: string;
    name: UserRole;
    description: string;
  };
  roleId: string;
  providers: string[];
  externalId: string;
  createdAt: string;
  updatedAt: string;
  companyId: string | null;
  company?: {
    id: string;
    name: string;
  } | null;
  // User permissions
  permissions: string[];
}

export interface SyncUserRequest {
  firstName?: string;
  lastName?: string;
}

export const userSyncApi = {
  // Sync Supabase user with local database
  syncUser: async (data?: SyncUserRequest): Promise<LocalUser> => {
    return apiClient.post<LocalUser>("/v1/auth/sync-user", data);
  },
};

export default userSyncApi;
